export const bookingRowUrlPattern = '/LeoSeaPortal/bookingdetails?shipmentId='
export const bookingRowIdField = 'shipmentID';
export const quoteRowUrlPattern = '/LeoSeaPortal/quotedetails?shipmentId=';
export const quoteRowIdField = 'shipmentID';
export const idField = 'shipmentID';